import { StaticBaseDao } from '@/dao';
import { RankingCategory } from '@/objects/generated';

export class RankingCategoryDao extends StaticBaseDao {
    public static async GetRankingCategoriesForEvent(EventID: number): Promise<RankingCategory[]> {
        return this.BaseFetchArray(
            RankingCategory,
            `RankingCategory/GetRankingCategoriesForEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
}
